<template>
    <b-modal id="modal-catatan-log-kas-kecil" title="Catatan Pengeluaran" ok-only ok-title="Tutup">
        <div v-if="item">
            <div class="mb-3">
                <div class="small text-muted">Catatan Penginputan</div>
                <div class="catatan-log-text">{{ item.notes || "-" }}</div>
            </div>
            <div v-if="showReason" class="mb-3">
                <div class="small text-muted">{{ reasonLabel }}</div>
                <div class="catatan-log-text">{{ item.voidReason || "-" }}</div>
            </div>
            <div v-if="returnInfo" class="mb-3">
                <div class="small text-muted">Catatan Konfirmasi Pengembalian</div>
                <div class="catatan-log-text">{{ returnInfo.reason || "-" }}</div>
            </div>
            <div v-if="returnInfo">
                <div class="small text-muted">Dikonfirmasi</div>
                <div class="catatan-log-text">{{ returnInfo.returnedAt }} oleh {{ returnInfo.returnedBy }}</div>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: "modal-kas-kecil-catatan",
    props: {
        item: { type: Object, default: null },
        showReason: { type: Boolean, default: false },
        reasonLabel: { type: String, default: "" },
        returnInfo: { type: Object, default: null },
    },
}
</script>

<style scoped>
.catatan-log-text {
    max-width: 100%;
    overflow-wrap: anywhere;
    white-space: pre-wrap;
    word-break: break-word;
}
</style>
